import { createTrackingHoc } from '@xingternal/malt-tracking';

import {
  CHANNEL_NEWS_PAGE,
  CHANNEL_INSIDER_PAGE,
  PROP_CHANNEL,
  TYPE_PAGEVIEW,
} from './constants';

import createAsyncTrackingHoc from './asyncTrackingHoc';

const withNewsPageviewTracking = createTrackingHoc(TYPE_PAGEVIEW, {
  [PROP_CHANNEL]: CHANNEL_NEWS_PAGE,
});

const withInsiderPageviewTracking = createAsyncTrackingHoc(TYPE_PAGEVIEW, {
  [PROP_CHANNEL]: CHANNEL_INSIDER_PAGE,
});

export { withNewsPageviewTracking, withInsiderPageviewTracking };
